"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * 易帆项目接口
 * 接口文档
 *
 * The version of the OpenAPI document: 1.0
 * Contact: 1357520721@qq.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserApi = exports.UserApiFactory = exports.UserApiFp = exports.UserApiAxiosParamCreator = exports.UploadFilesUsingPOSTTypeEnum = exports.CoreApi = exports.CoreApiFactory = exports.CoreApiFp = exports.CoreApiAxiosParamCreator = exports.ClassHourApi = exports.ClassHourApiFactory = exports.ClassHourApiFp = exports.ClassHourApiAxiosParamCreator = exports.ClassApi = exports.ClassApiFactory = exports.ClassApiFp = exports.ClassApiAxiosParamCreator = exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.GetUploadFileTokenRequestTypeEnum = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
exports.GetUploadFileTokenRequestTypeEnum = {
    COURSE_SUMMARY_HOMEWORK: 'COURSE_SUMMARY_HOMEWORK',
    COURSE_SUMMARY_NOTE: 'COURSE_SUMMARY_NOTE',
    COURSE_SUMMARY_VIDEO: 'COURSE_SUMMARY_VIDEO'
};
/**
 * DefaultApi - axios parameter creator
 * @export
 */
var DefaultApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 新增班级
         * @param {number} course 科目
         * @param {number} hours 总课时
         * @param {number} name 班级名称
         * @param {number} price 单价
         * @param {number} sids 学生ID集合
         * @param {number} students 学生集合
         * @param {number} teacher 老师
         * @param {number} teaprice 老师价格
         * @param {number} tid 老师ID
         * @param {number} timemodel 时间模板
         * @param {number} times 时间集合
         * @param {number} weeknum 周数量
         * @param {number} zoom zoom号
         * @param {number} [isaddhour] 是否补课时,默认0
         * @param {number} [pid] 续哪个班,默认0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsingPOST: function (course_1, hours_1, name_1, price_1, sids_1, students_1, teacher_1, teaprice_1, tid_1, timemodel_1, times_1, weeknum_1, zoom_1, isaddhour_1, pid_1) {
            var args_1 = [];
            for (var _i = 15; _i < arguments.length; _i++) {
                args_1[_i - 15] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([course_1, hours_1, name_1, price_1, sids_1, students_1, teacher_1, teaprice_1, tid_1, timemodel_1, times_1, weeknum_1, zoom_1, isaddhour_1, pid_1], args_1, true), void 0, function (course, hours, name, price, sids, students, teacher, teaprice, tid, timemodel, times, weeknum, zoom, isaddhour, pid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'course' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'course', course);
                    // verify required parameter 'hours' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'hours', hours);
                    // verify required parameter 'name' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'name', name);
                    // verify required parameter 'price' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'price', price);
                    // verify required parameter 'sids' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'sids', sids);
                    // verify required parameter 'students' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'students', students);
                    // verify required parameter 'teacher' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'teacher', teacher);
                    // verify required parameter 'teaprice' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'teaprice', teaprice);
                    // verify required parameter 'tid' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'tid', tid);
                    // verify required parameter 'timemodel' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'timemodel', timemodel);
                    // verify required parameter 'times' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'times', times);
                    // verify required parameter 'weeknum' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'weeknum', weeknum);
                    // verify required parameter 'zoom' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'zoom', zoom);
                    localVarPath = "/japi/class";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (course !== undefined) {
                        localVarQueryParameter['course'] = course;
                    }
                    if (hours !== undefined) {
                        localVarQueryParameter['hours'] = hours;
                    }
                    if (isaddhour !== undefined) {
                        localVarQueryParameter['isaddhour'] = isaddhour;
                    }
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (pid !== undefined) {
                        localVarQueryParameter['pid'] = pid;
                    }
                    if (price !== undefined) {
                        localVarQueryParameter['price'] = price;
                    }
                    if (sids !== undefined) {
                        localVarQueryParameter['sids'] = sids;
                    }
                    if (students !== undefined) {
                        localVarQueryParameter['students'] = students;
                    }
                    if (teacher !== undefined) {
                        localVarQueryParameter['teacher'] = teacher;
                    }
                    if (teaprice !== undefined) {
                        localVarQueryParameter['teaprice'] = teaprice;
                    }
                    if (tid !== undefined) {
                        localVarQueryParameter['tid'] = tid;
                    }
                    if (timemodel !== undefined) {
                        localVarQueryParameter['timemodel'] = timemodel;
                    }
                    if (times !== undefined) {
                        localVarQueryParameter['times'] = times;
                    }
                    if (weeknum !== undefined) {
                        localVarQueryParameter['weeknum'] = weeknum;
                    }
                    if (zoom !== undefined) {
                        localVarQueryParameter['zoom'] = zoom;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 新增科目
         * @param {number} chours 总课时数
         * @param {number} isHome 是否首页显示
         * @param {string} link 链接
         * @param {string} name 名称
         * @param {string} remark 备注
         * @param {string} shortname 简称
         * @param {number} sort 顺序
         * @param {string} url 路径
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsingPOST1: function (chours_1, isHome_1, link_1, name_1, remark_1, shortname_1, sort_1, url_1) {
            var args_1 = [];
            for (var _i = 8; _i < arguments.length; _i++) {
                args_1[_i - 8] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([chours_1, isHome_1, link_1, name_1, remark_1, shortname_1, sort_1, url_1], args_1, true), void 0, function (chours, isHome, link, name, remark, shortname, sort, url, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'chours' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST1', 'chours', chours);
                    // verify required parameter 'isHome' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST1', 'isHome', isHome);
                    // verify required parameter 'link' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST1', 'link', link);
                    // verify required parameter 'name' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST1', 'name', name);
                    // verify required parameter 'remark' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST1', 'remark', remark);
                    // verify required parameter 'shortname' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST1', 'shortname', shortname);
                    // verify required parameter 'sort' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST1', 'sort', sort);
                    // verify required parameter 'url' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST1', 'url', url);
                    localVarPath = "/japi/course";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (chours !== undefined) {
                        localVarQueryParameter['chours'] = chours;
                    }
                    if (isHome !== undefined) {
                        localVarQueryParameter['isHome'] = isHome;
                    }
                    if (link !== undefined) {
                        localVarQueryParameter['link'] = link;
                    }
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (remark !== undefined) {
                        localVarQueryParameter['remark'] = remark;
                    }
                    if (shortname !== undefined) {
                        localVarQueryParameter['shortname'] = shortname;
                    }
                    if (sort !== undefined) {
                        localVarQueryParameter['sort'] = sort;
                    }
                    if (url !== undefined) {
                        localVarQueryParameter['url'] = url;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 上传作业(报告)
         * @param {string} url 文件路径（多个用竖杆\&#39;|\&#39;拼接）
         * @param {number} [chid] 课时ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsingPOST2: function (url_1, chid_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([url_1, chid_1], args_1, true), void 0, function (url, chid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'url' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST2', 'url', url);
                    localVarPath = "/japi/work";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (chid !== undefined) {
                        localVarQueryParameter['chid'] = chid;
                    }
                    if (url !== undefined) {
                        localVarQueryParameter['url'] = url;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 上传课时总结报告
         * @param {number} classHourId 课程 Id
         * @param {ClassHourSummaryRequest} [classHourSummaryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSummaryUsingPOST: function (classHourId_1, classHourSummaryRequest_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([classHourId_1, classHourSummaryRequest_1], args_1, true), void 0, function (classHourId, classHourSummaryRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'classHourId' is not null or undefined
                    (0, common_1.assertParamExists)('createSummaryUsingPOST', 'classHourId', classHourId);
                    localVarPath = "/japi/class-hour/{classHourId}/summary"
                        .replace("{".concat("classHourId", "}"), encodeURIComponent(String(classHourId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(classHourSummaryRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 删除科目
         * @param {number} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delUsingDELETE: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('delUsingDELETE', 'id', id);
                    localVarPath = "/japi/course/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 冻结课时
         * @param {string} ids 课时ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frozenUsingPUT: function (ids_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([ids_1], args_1, true), void 0, function (ids, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'ids' is not null or undefined
                    (0, common_1.assertParamExists)('frozenUsingPUT', 'ids', ids);
                    localVarPath = "/japi/class_hour/frozen";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (ids !== undefined) {
                        localVarQueryParameter['ids'] = ids;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 根据班级查课时
         * @param {number} classid 班级ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClassHourByClassUsingGET: function (classid_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([classid_1], args_1, true), void 0, function (classid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'classid' is not null or undefined
                    (0, common_1.assertParamExists)('getClassHourByClassUsingGET', 'classid', classid);
                    localVarPath = "/japi/class_hour/getByClass/{classid}"
                        .replace("{".concat("classid", "}"), encodeURIComponent(String(classid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 根据班级查课时
         * @param {number} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClassHourByIdUsingGET: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getClassHourByIdUsingGET', 'id', id);
                    localVarPath = "/japi/class-hour/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 查询学生作业
         * @param {number} chid 课时ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStudentWorkUsingGET: function (chid_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([chid_1], args_1, true), void 0, function (chid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'chid' is not null or undefined
                    (0, common_1.assertParamExists)('getStudentWorkUsingGET', 'chid', chid);
                    localVarPath = "/japi/work/get_student_work/{chid}"
                        .replace("{".concat("chid", "}"), encodeURIComponent(String(chid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取课时总结报告
         * @param {number} classHourId 课程 Id
         * @param {number} id 课程报告Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryUsingGET: function (classHourId_1, id_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([classHourId_1, id_1], args_1, true), void 0, function (classHourId, id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'classHourId' is not null or undefined
                    (0, common_1.assertParamExists)('getSummaryUsingGET', 'classHourId', classHourId);
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getSummaryUsingGET', 'id', id);
                    localVarPath = "/japi/class-hour/{classHourId}/summary/{id}"
                        .replace("{".concat("classHourId", "}"), encodeURIComponent(String(classHourId)))
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取学校列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsingGET: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/japi/school";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 登录
         * @param {string} password 密码
         * @param {string} username 用户名
         * @param {string} [openid] 微信OPENID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginUsingPOST: function (password_1, username_1, openid_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([password_1, username_1, openid_1], args_1, true), void 0, function (password, username, openid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'password' is not null or undefined
                    (0, common_1.assertParamExists)('loginUsingPOST', 'password', password);
                    // verify required parameter 'username' is not null or undefined
                    (0, common_1.assertParamExists)('loginUsingPOST', 'username', username);
                    localVarPath = "/japi/user/login";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (openid !== undefined) {
                        localVarQueryParameter['openid'] = openid;
                    }
                    if (password !== undefined) {
                        localVarQueryParameter['password'] = password;
                    }
                    if (username !== undefined) {
                        localVarQueryParameter['username'] = username;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 微信登录回调
         * @param {string} code code
         * @param {string} state state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithWechatCallbackUsingGET: function (code_1, state_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([code_1, state_1], args_1, true), void 0, function (code, state, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'code' is not null or undefined
                    (0, common_1.assertParamExists)('loginWithWechatCallbackUsingGET', 'code', code);
                    // verify required parameter 'state' is not null or undefined
                    (0, common_1.assertParamExists)('loginWithWechatCallbackUsingGET', 'state', state);
                    localVarPath = "/japi/user/login/wechat/callback";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (code !== undefined) {
                        localVarQueryParameter['code'] = code;
                    }
                    if (state !== undefined) {
                        localVarQueryParameter['state'] = state;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 微信登录
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithWechatUsingGET: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/japi/user/login/wechat";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取当前登录状态
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        meUsingGET: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/japi/user/me";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 查询班级分页
         * @param {string} [name] 名称
         * @param {number} [page] 页码
         * @param {number} [showType] 1全部,2未上完
         * @param {number} [size] 每页显示数量
         * @param {number} [teaid] 老师ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsingGET: function (name_1, page_1, showType_1, size_1, teaid_1) {
            var args_1 = [];
            for (var _i = 5; _i < arguments.length; _i++) {
                args_1[_i - 5] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([name_1, page_1, showType_1, size_1, teaid_1], args_1, true), void 0, function (name, page, showType, size, teaid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/japi/class/page";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (showType !== undefined) {
                        localVarQueryParameter['showType'] = showType;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (teaid !== undefined) {
                        localVarQueryParameter['teaid'] = teaid;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 查询科目分页
         * @param {string} [name] 科目名称
         * @param {number} [page] 页码
         * @param {number} [size] 每页显示数量
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsingGET1: function (name_1, page_1, size_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([name_1, page_1, size_1], args_1, true), void 0, function (name, page, size, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/japi/course/page";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 查询科目级别分页
         * @param {number} [page] 页码
         * @param {number} [size] 每页显示数量
         * @param {string} [name] name
         * @param {string} [level] level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsingGET2: function (page_1, size_1, name_1, level_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([page_1, size_1, name_1, level_1], args_1, true), void 0, function (page, size, name, level, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/japi/course_level/page";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (level !== undefined) {
                        localVarQueryParameter['level'] = level;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 查询用户分页
         * @param {number} [name] 名称、手机号、邮箱
         * @param {number} [page] 页码
         * @param {number} [roleid] 角色ID
         * @param {number} [size] 每页显示数量
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsingGET3: function (name_1, page_1, roleid_1, size_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([name_1, page_1, roleid_1, size_1], args_1, true), void 0, function (name, page, roleid, size, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/japi/user/page";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (roleid !== undefined) {
                        localVarQueryParameter['roleid'] = roleid;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 取消课时
         * @param {string} course 科目
         * @param {string} curTime 时间
         * @param {string} to 发给谁
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendCancelClassUsingPOST: function (course_1, curTime_1, to_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([course_1, curTime_1, to_1], args_1, true), void 0, function (course, curTime, to, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'course' is not null or undefined
                    (0, common_1.assertParamExists)('sendCancelClassUsingPOST', 'course', course);
                    // verify required parameter 'curTime' is not null or undefined
                    (0, common_1.assertParamExists)('sendCancelClassUsingPOST', 'curTime', curTime);
                    // verify required parameter 'to' is not null or undefined
                    (0, common_1.assertParamExists)('sendCancelClassUsingPOST', 'to', to);
                    localVarPath = "/japi/mail/cancelClass";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (course !== undefined) {
                        localVarQueryParameter['course'] = course;
                    }
                    if (curTime !== undefined) {
                        localVarQueryParameter['curTime'] = curTime;
                    }
                    if (to !== undefined) {
                        localVarQueryParameter['to'] = to;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 发送网页
         * @param {string} content 内容
         * @param {string} title 标题
         * @param {string} to 发给谁
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendHtmlMailUsingPOST: function (content_1, title_1, to_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([content_1, title_1, to_1], args_1, true), void 0, function (content, title, to, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'content' is not null or undefined
                    (0, common_1.assertParamExists)('sendHtmlMailUsingPOST', 'content', content);
                    // verify required parameter 'title' is not null or undefined
                    (0, common_1.assertParamExists)('sendHtmlMailUsingPOST', 'title', title);
                    // verify required parameter 'to' is not null or undefined
                    (0, common_1.assertParamExists)('sendHtmlMailUsingPOST', 'to', to);
                    localVarPath = "/japi/mail/html";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (content !== undefined) {
                        localVarQueryParameter['content'] = content;
                    }
                    if (title !== undefined) {
                        localVarQueryParameter['title'] = title;
                    }
                    if (to !== undefined) {
                        localVarQueryParameter['to'] = to;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 发送文本
         * @param {string} content 内容
         * @param {string} title 标题
         * @param {string} to 发给谁
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTextMailUsingPOST: function (content_1, title_1, to_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([content_1, title_1, to_1], args_1, true), void 0, function (content, title, to, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'content' is not null or undefined
                    (0, common_1.assertParamExists)('sendTextMailUsingPOST', 'content', content);
                    // verify required parameter 'title' is not null or undefined
                    (0, common_1.assertParamExists)('sendTextMailUsingPOST', 'title', title);
                    // verify required parameter 'to' is not null or undefined
                    (0, common_1.assertParamExists)('sendTextMailUsingPOST', 'to', to);
                    localVarPath = "/japi/mail/text";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (content !== undefined) {
                        localVarQueryParameter['content'] = content;
                    }
                    if (title !== undefined) {
                        localVarQueryParameter['title'] = title;
                    }
                    if (to !== undefined) {
                        localVarQueryParameter['to'] = to;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 可用时间规划
         * @param {number} userId userId
         * @param {UpdateUserCronEventReq} [updateUserCronEventReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCronEventsUsingPUT: function (userId_1, updateUserCronEventReq_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([userId_1, updateUserCronEventReq_1], args_1, true), void 0, function (userId, updateUserCronEventReq, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'userId' is not null or undefined
                    (0, common_1.assertParamExists)('updateCronEventsUsingPUT', 'userId', userId);
                    localVarPath = "/japi/user/{userId}/cron-events"
                        .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateUserCronEventReq, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 修改课时总结报告
         * @param {number} classHourId 课程 Id
         * @param {number} id 课程报告Id
         * @param {ClassHourSummaryRequest} [classHourSummaryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSummaryUsingPUT: function (classHourId_1, id_1, classHourSummaryRequest_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([classHourId_1, id_1, classHourSummaryRequest_1], args_1, true), void 0, function (classHourId, id, classHourSummaryRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'classHourId' is not null or undefined
                    (0, common_1.assertParamExists)('updateSummaryUsingPUT', 'classHourId', classHourId);
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateSummaryUsingPUT', 'id', id);
                    localVarPath = "/japi/class-hour/{classHourId}/summary/{id}"
                        .replace("{".concat("classHourId", "}"), encodeURIComponent(String(classHourId)))
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(classHourSummaryRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 修改科目(注:每项参数都必传)
         * @param {number} chours 总课时数
         * @param {number} id 名称
         * @param {number} isHome 是否首页显示
         * @param {string} link 链接
         * @param {string} name 名称
         * @param {string} remark 备注
         * @param {string} shortname 简称
         * @param {number} sort 顺序
         * @param {string} url 路径
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUsingPUT: function (chours_1, id_1, isHome_1, link_1, name_1, remark_1, shortname_1, sort_1, url_1) {
            var args_1 = [];
            for (var _i = 9; _i < arguments.length; _i++) {
                args_1[_i - 9] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([chours_1, id_1, isHome_1, link_1, name_1, remark_1, shortname_1, sort_1, url_1], args_1, true), void 0, function (chours, id, isHome, link, name, remark, shortname, sort, url, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'chours' is not null or undefined
                    (0, common_1.assertParamExists)('updateUsingPUT', 'chours', chours);
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateUsingPUT', 'id', id);
                    // verify required parameter 'isHome' is not null or undefined
                    (0, common_1.assertParamExists)('updateUsingPUT', 'isHome', isHome);
                    // verify required parameter 'link' is not null or undefined
                    (0, common_1.assertParamExists)('updateUsingPUT', 'link', link);
                    // verify required parameter 'name' is not null or undefined
                    (0, common_1.assertParamExists)('updateUsingPUT', 'name', name);
                    // verify required parameter 'remark' is not null or undefined
                    (0, common_1.assertParamExists)('updateUsingPUT', 'remark', remark);
                    // verify required parameter 'shortname' is not null or undefined
                    (0, common_1.assertParamExists)('updateUsingPUT', 'shortname', shortname);
                    // verify required parameter 'sort' is not null or undefined
                    (0, common_1.assertParamExists)('updateUsingPUT', 'sort', sort);
                    // verify required parameter 'url' is not null or undefined
                    (0, common_1.assertParamExists)('updateUsingPUT', 'url', url);
                    localVarPath = "/japi/course";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (chours !== undefined) {
                        localVarQueryParameter['chours'] = chours;
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (isHome !== undefined) {
                        localVarQueryParameter['isHome'] = isHome;
                    }
                    if (link !== undefined) {
                        localVarQueryParameter['link'] = link;
                    }
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (remark !== undefined) {
                        localVarQueryParameter['remark'] = remark;
                    }
                    if (shortname !== undefined) {
                        localVarQueryParameter['shortname'] = shortname;
                    }
                    if (sort !== undefined) {
                        localVarQueryParameter['sort'] = sort;
                    }
                    if (url !== undefined) {
                        localVarQueryParameter['url'] = url;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 上传
         * @param {number} type 类型1.图片，2.文件，3.受保护的(头像、科目等后期不清理的存放处)
         * @param {File} file file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImgUsingPOST: function (type_1, file_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([type_1, file_1], args_1, true), void 0, function (type, file, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'type' is not null or undefined
                    (0, common_1.assertParamExists)('uploadImgUsingPOST', 'type', type);
                    // verify required parameter 'file' is not null or undefined
                    (0, common_1.assertParamExists)('uploadImgUsingPOST', 'file', file);
                    localVarPath = "/japi/file/upload";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                    if (type !== undefined) {
                        localVarQueryParameter['type'] = type;
                    }
                    if (file !== undefined) {
                        localVarFormParams.append('file', file);
                    }
                    localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = localVarFormParams;
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 校验是否有冲突时间段
         * @param {VerifyClassTimeConflictReq} [verifyClassTimeConflictReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateConflictTimesUsingPOST: function (verifyClassTimeConflictReq_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([verifyClassTimeConflictReq_1], args_1, true), void 0, function (verifyClassTimeConflictReq, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/japi/class/verify-conflicts";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(verifyClassTimeConflictReq, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
var DefaultApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 新增班级
         * @param {number} course 科目
         * @param {number} hours 总课时
         * @param {number} name 班级名称
         * @param {number} price 单价
         * @param {number} sids 学生ID集合
         * @param {number} students 学生集合
         * @param {number} teacher 老师
         * @param {number} teaprice 老师价格
         * @param {number} tid 老师ID
         * @param {number} timemodel 时间模板
         * @param {number} times 时间集合
         * @param {number} weeknum 周数量
         * @param {number} zoom zoom号
         * @param {number} [isaddhour] 是否补课时,默认0
         * @param {number} [pid] 续哪个班,默认0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsingPOST: function (course, hours, name, price, sids, students, teacher, teaprice, tid, timemodel, times, weeknum, zoom, isaddhour, pid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addUsingPOST(course, hours, name, price, sids, students, teacher, teaprice, tid, timemodel, times, weeknum, zoom, isaddhour, pid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.addUsingPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 新增科目
         * @param {number} chours 总课时数
         * @param {number} isHome 是否首页显示
         * @param {string} link 链接
         * @param {string} name 名称
         * @param {string} remark 备注
         * @param {string} shortname 简称
         * @param {number} sort 顺序
         * @param {string} url 路径
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsingPOST1: function (chours, isHome, link, name, remark, shortname, sort, url, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addUsingPOST1(chours, isHome, link, name, remark, shortname, sort, url, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.addUsingPOST1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 上传作业(报告)
         * @param {string} url 文件路径（多个用竖杆\&#39;|\&#39;拼接）
         * @param {number} [chid] 课时ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsingPOST2: function (url, chid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addUsingPOST2(url, chid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.addUsingPOST2']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 上传课时总结报告
         * @param {number} classHourId 课程 Id
         * @param {ClassHourSummaryRequest} [classHourSummaryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSummaryUsingPOST: function (classHourId, classHourSummaryRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSummaryUsingPOST(classHourId, classHourSummaryRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.createSummaryUsingPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 删除科目
         * @param {number} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delUsingDELETE: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.delUsingDELETE(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.delUsingDELETE']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 冻结课时
         * @param {string} ids 课时ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frozenUsingPUT: function (ids, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.frozenUsingPUT(ids, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.frozenUsingPUT']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 根据班级查课时
         * @param {number} classid 班级ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClassHourByClassUsingGET: function (classid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getClassHourByClassUsingGET(classid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.getClassHourByClassUsingGET']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 根据班级查课时
         * @param {number} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClassHourByIdUsingGET: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getClassHourByIdUsingGET(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.getClassHourByIdUsingGET']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 查询学生作业
         * @param {number} chid 课时ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStudentWorkUsingGET: function (chid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getStudentWorkUsingGET(chid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.getStudentWorkUsingGET']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取课时总结报告
         * @param {number} classHourId 课程 Id
         * @param {number} id 课程报告Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryUsingGET: function (classHourId, id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSummaryUsingGET(classHourId, id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.getSummaryUsingGET']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取学校列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsingGET: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listUsingGET(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.listUsingGET']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 登录
         * @param {string} password 密码
         * @param {string} username 用户名
         * @param {string} [openid] 微信OPENID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginUsingPOST: function (password, username, openid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loginUsingPOST(password, username, openid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.loginUsingPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 微信登录回调
         * @param {string} code code
         * @param {string} state state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithWechatCallbackUsingGET: function (code, state, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loginWithWechatCallbackUsingGET(code, state, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.loginWithWechatCallbackUsingGET']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 微信登录
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithWechatUsingGET: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loginWithWechatUsingGET(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.loginWithWechatUsingGET']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取当前登录状态
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        meUsingGET: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.meUsingGET(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.meUsingGET']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 查询班级分页
         * @param {string} [name] 名称
         * @param {number} [page] 页码
         * @param {number} [showType] 1全部,2未上完
         * @param {number} [size] 每页显示数量
         * @param {number} [teaid] 老师ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsingGET: function (name, page, showType, size, teaid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.pageUsingGET(name, page, showType, size, teaid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.pageUsingGET']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 查询科目分页
         * @param {string} [name] 科目名称
         * @param {number} [page] 页码
         * @param {number} [size] 每页显示数量
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsingGET1: function (name, page, size, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.pageUsingGET1(name, page, size, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.pageUsingGET1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 查询科目级别分页
         * @param {number} [page] 页码
         * @param {number} [size] 每页显示数量
         * @param {string} [name] name
         * @param {string} [level] level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsingGET2: function (page, size, name, level, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.pageUsingGET2(page, size, name, level, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.pageUsingGET2']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 查询用户分页
         * @param {number} [name] 名称、手机号、邮箱
         * @param {number} [page] 页码
         * @param {number} [roleid] 角色ID
         * @param {number} [size] 每页显示数量
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsingGET3: function (name, page, roleid, size, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.pageUsingGET3(name, page, roleid, size, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.pageUsingGET3']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 取消课时
         * @param {string} course 科目
         * @param {string} curTime 时间
         * @param {string} to 发给谁
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendCancelClassUsingPOST: function (course, curTime, to, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.sendCancelClassUsingPOST(course, curTime, to, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.sendCancelClassUsingPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 发送网页
         * @param {string} content 内容
         * @param {string} title 标题
         * @param {string} to 发给谁
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendHtmlMailUsingPOST: function (content, title, to, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.sendHtmlMailUsingPOST(content, title, to, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.sendHtmlMailUsingPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 发送文本
         * @param {string} content 内容
         * @param {string} title 标题
         * @param {string} to 发给谁
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTextMailUsingPOST: function (content, title, to, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.sendTextMailUsingPOST(content, title, to, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.sendTextMailUsingPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 可用时间规划
         * @param {number} userId userId
         * @param {UpdateUserCronEventReq} [updateUserCronEventReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCronEventsUsingPUT: function (userId, updateUserCronEventReq, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCronEventsUsingPUT(userId, updateUserCronEventReq, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.updateCronEventsUsingPUT']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 修改课时总结报告
         * @param {number} classHourId 课程 Id
         * @param {number} id 课程报告Id
         * @param {ClassHourSummaryRequest} [classHourSummaryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSummaryUsingPUT: function (classHourId, id, classHourSummaryRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSummaryUsingPUT(classHourId, id, classHourSummaryRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.updateSummaryUsingPUT']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 修改科目(注:每项参数都必传)
         * @param {number} chours 总课时数
         * @param {number} id 名称
         * @param {number} isHome 是否首页显示
         * @param {string} link 链接
         * @param {string} name 名称
         * @param {string} remark 备注
         * @param {string} shortname 简称
         * @param {number} sort 顺序
         * @param {string} url 路径
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUsingPUT: function (chours, id, isHome, link, name, remark, shortname, sort, url, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateUsingPUT(chours, id, isHome, link, name, remark, shortname, sort, url, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.updateUsingPUT']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 上传
         * @param {number} type 类型1.图片，2.文件，3.受保护的(头像、科目等后期不清理的存放处)
         * @param {File} file file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImgUsingPOST: function (type, file, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.uploadImgUsingPOST(type, file, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.uploadImgUsingPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 校验是否有冲突时间段
         * @param {VerifyClassTimeConflictReq} [verifyClassTimeConflictReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateConflictTimesUsingPOST: function (verifyClassTimeConflictReq, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.validateConflictTimesUsingPOST(verifyClassTimeConflictReq, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DefaultApi.validateConflictTimesUsingPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
var DefaultApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         *
         * @summary 新增班级
         * @param {number} course 科目
         * @param {number} hours 总课时
         * @param {number} name 班级名称
         * @param {number} price 单价
         * @param {number} sids 学生ID集合
         * @param {number} students 学生集合
         * @param {number} teacher 老师
         * @param {number} teaprice 老师价格
         * @param {number} tid 老师ID
         * @param {number} timemodel 时间模板
         * @param {number} times 时间集合
         * @param {number} weeknum 周数量
         * @param {number} zoom zoom号
         * @param {number} [isaddhour] 是否补课时,默认0
         * @param {number} [pid] 续哪个班,默认0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsingPOST: function (course, hours, name, price, sids, students, teacher, teaprice, tid, timemodel, times, weeknum, zoom, isaddhour, pid, options) {
            return localVarFp.addUsingPOST(course, hours, name, price, sids, students, teacher, teaprice, tid, timemodel, times, weeknum, zoom, isaddhour, pid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 新增科目
         * @param {number} chours 总课时数
         * @param {number} isHome 是否首页显示
         * @param {string} link 链接
         * @param {string} name 名称
         * @param {string} remark 备注
         * @param {string} shortname 简称
         * @param {number} sort 顺序
         * @param {string} url 路径
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsingPOST1: function (chours, isHome, link, name, remark, shortname, sort, url, options) {
            return localVarFp.addUsingPOST1(chours, isHome, link, name, remark, shortname, sort, url, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 上传作业(报告)
         * @param {string} url 文件路径（多个用竖杆\&#39;|\&#39;拼接）
         * @param {number} [chid] 课时ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsingPOST2: function (url, chid, options) {
            return localVarFp.addUsingPOST2(url, chid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 上传课时总结报告
         * @param {number} classHourId 课程 Id
         * @param {ClassHourSummaryRequest} [classHourSummaryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSummaryUsingPOST: function (classHourId, classHourSummaryRequest, options) {
            return localVarFp.createSummaryUsingPOST(classHourId, classHourSummaryRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 删除科目
         * @param {number} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        delUsingDELETE: function (id, options) {
            return localVarFp.delUsingDELETE(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 冻结课时
         * @param {string} ids 课时ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frozenUsingPUT: function (ids, options) {
            return localVarFp.frozenUsingPUT(ids, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 根据班级查课时
         * @param {number} classid 班级ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClassHourByClassUsingGET: function (classid, options) {
            return localVarFp.getClassHourByClassUsingGET(classid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 根据班级查课时
         * @param {number} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClassHourByIdUsingGET: function (id, options) {
            return localVarFp.getClassHourByIdUsingGET(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 查询学生作业
         * @param {number} chid 课时ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStudentWorkUsingGET: function (chid, options) {
            return localVarFp.getStudentWorkUsingGET(chid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取课时总结报告
         * @param {number} classHourId 课程 Id
         * @param {number} id 课程报告Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryUsingGET: function (classHourId, id, options) {
            return localVarFp.getSummaryUsingGET(classHourId, id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取学校列表
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsingGET: function (options) {
            return localVarFp.listUsingGET(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 登录
         * @param {string} password 密码
         * @param {string} username 用户名
         * @param {string} [openid] 微信OPENID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginUsingPOST: function (password, username, openid, options) {
            return localVarFp.loginUsingPOST(password, username, openid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 微信登录回调
         * @param {string} code code
         * @param {string} state state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithWechatCallbackUsingGET: function (code, state, options) {
            return localVarFp.loginWithWechatCallbackUsingGET(code, state, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 微信登录
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithWechatUsingGET: function (options) {
            return localVarFp.loginWithWechatUsingGET(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取当前登录状态
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        meUsingGET: function (options) {
            return localVarFp.meUsingGET(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 查询班级分页
         * @param {string} [name] 名称
         * @param {number} [page] 页码
         * @param {number} [showType] 1全部,2未上完
         * @param {number} [size] 每页显示数量
         * @param {number} [teaid] 老师ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsingGET: function (name, page, showType, size, teaid, options) {
            return localVarFp.pageUsingGET(name, page, showType, size, teaid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 查询科目分页
         * @param {string} [name] 科目名称
         * @param {number} [page] 页码
         * @param {number} [size] 每页显示数量
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsingGET1: function (name, page, size, options) {
            return localVarFp.pageUsingGET1(name, page, size, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 查询科目级别分页
         * @param {number} [page] 页码
         * @param {number} [size] 每页显示数量
         * @param {string} [name] name
         * @param {string} [level] level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsingGET2: function (page, size, name, level, options) {
            return localVarFp.pageUsingGET2(page, size, name, level, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 查询用户分页
         * @param {number} [name] 名称、手机号、邮箱
         * @param {number} [page] 页码
         * @param {number} [roleid] 角色ID
         * @param {number} [size] 每页显示数量
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsingGET3: function (name, page, roleid, size, options) {
            return localVarFp.pageUsingGET3(name, page, roleid, size, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 取消课时
         * @param {string} course 科目
         * @param {string} curTime 时间
         * @param {string} to 发给谁
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendCancelClassUsingPOST: function (course, curTime, to, options) {
            return localVarFp.sendCancelClassUsingPOST(course, curTime, to, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 发送网页
         * @param {string} content 内容
         * @param {string} title 标题
         * @param {string} to 发给谁
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendHtmlMailUsingPOST: function (content, title, to, options) {
            return localVarFp.sendHtmlMailUsingPOST(content, title, to, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 发送文本
         * @param {string} content 内容
         * @param {string} title 标题
         * @param {string} to 发给谁
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTextMailUsingPOST: function (content, title, to, options) {
            return localVarFp.sendTextMailUsingPOST(content, title, to, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 可用时间规划
         * @param {number} userId userId
         * @param {UpdateUserCronEventReq} [updateUserCronEventReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCronEventsUsingPUT: function (userId, updateUserCronEventReq, options) {
            return localVarFp.updateCronEventsUsingPUT(userId, updateUserCronEventReq, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 修改课时总结报告
         * @param {number} classHourId 课程 Id
         * @param {number} id 课程报告Id
         * @param {ClassHourSummaryRequest} [classHourSummaryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSummaryUsingPUT: function (classHourId, id, classHourSummaryRequest, options) {
            return localVarFp.updateSummaryUsingPUT(classHourId, id, classHourSummaryRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 修改科目(注:每项参数都必传)
         * @param {number} chours 总课时数
         * @param {number} id 名称
         * @param {number} isHome 是否首页显示
         * @param {string} link 链接
         * @param {string} name 名称
         * @param {string} remark 备注
         * @param {string} shortname 简称
         * @param {number} sort 顺序
         * @param {string} url 路径
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUsingPUT: function (chours, id, isHome, link, name, remark, shortname, sort, url, options) {
            return localVarFp.updateUsingPUT(chours, id, isHome, link, name, remark, shortname, sort, url, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 上传
         * @param {number} type 类型1.图片，2.文件，3.受保护的(头像、科目等后期不清理的存放处)
         * @param {File} file file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImgUsingPOST: function (type, file, options) {
            return localVarFp.uploadImgUsingPOST(type, file, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 校验是否有冲突时间段
         * @param {VerifyClassTimeConflictReq} [verifyClassTimeConflictReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateConflictTimesUsingPOST: function (verifyClassTimeConflictReq, options) {
            return localVarFp.validateConflictTimesUsingPOST(verifyClassTimeConflictReq, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
var DefaultApi = /** @class */ (function (_super) {
    __extends(DefaultApi, _super);
    function DefaultApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 新增班级
     * @param {number} course 科目
     * @param {number} hours 总课时
     * @param {number} name 班级名称
     * @param {number} price 单价
     * @param {number} sids 学生ID集合
     * @param {number} students 学生集合
     * @param {number} teacher 老师
     * @param {number} teaprice 老师价格
     * @param {number} tid 老师ID
     * @param {number} timemodel 时间模板
     * @param {number} times 时间集合
     * @param {number} weeknum 周数量
     * @param {number} zoom zoom号
     * @param {number} [isaddhour] 是否补课时,默认0
     * @param {number} [pid] 续哪个班,默认0
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.addUsingPOST = function (course, hours, name, price, sids, students, teacher, teaprice, tid, timemodel, times, weeknum, zoom, isaddhour, pid, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).addUsingPOST(course, hours, name, price, sids, students, teacher, teaprice, tid, timemodel, times, weeknum, zoom, isaddhour, pid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 新增科目
     * @param {number} chours 总课时数
     * @param {number} isHome 是否首页显示
     * @param {string} link 链接
     * @param {string} name 名称
     * @param {string} remark 备注
     * @param {string} shortname 简称
     * @param {number} sort 顺序
     * @param {string} url 路径
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.addUsingPOST1 = function (chours, isHome, link, name, remark, shortname, sort, url, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).addUsingPOST1(chours, isHome, link, name, remark, shortname, sort, url, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 上传作业(报告)
     * @param {string} url 文件路径（多个用竖杆\&#39;|\&#39;拼接）
     * @param {number} [chid] 课时ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.addUsingPOST2 = function (url, chid, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).addUsingPOST2(url, chid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 上传课时总结报告
     * @param {number} classHourId 课程 Id
     * @param {ClassHourSummaryRequest} [classHourSummaryRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.createSummaryUsingPOST = function (classHourId, classHourSummaryRequest, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).createSummaryUsingPOST(classHourId, classHourSummaryRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 删除科目
     * @param {number} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.delUsingDELETE = function (id, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).delUsingDELETE(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 冻结课时
     * @param {string} ids 课时ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.frozenUsingPUT = function (ids, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).frozenUsingPUT(ids, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 根据班级查课时
     * @param {number} classid 班级ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getClassHourByClassUsingGET = function (classid, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getClassHourByClassUsingGET(classid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 根据班级查课时
     * @param {number} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getClassHourByIdUsingGET = function (id, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getClassHourByIdUsingGET(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 查询学生作业
     * @param {number} chid 课时ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getStudentWorkUsingGET = function (chid, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getStudentWorkUsingGET(chid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取课时总结报告
     * @param {number} classHourId 课程 Id
     * @param {number} id 课程报告Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.getSummaryUsingGET = function (classHourId, id, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getSummaryUsingGET(classHourId, id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取学校列表
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.listUsingGET = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).listUsingGET(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 登录
     * @param {string} password 密码
     * @param {string} username 用户名
     * @param {string} [openid] 微信OPENID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.loginUsingPOST = function (password, username, openid, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).loginUsingPOST(password, username, openid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 微信登录回调
     * @param {string} code code
     * @param {string} state state
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.loginWithWechatCallbackUsingGET = function (code, state, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).loginWithWechatCallbackUsingGET(code, state, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 微信登录
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.loginWithWechatUsingGET = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).loginWithWechatUsingGET(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取当前登录状态
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.meUsingGET = function (options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).meUsingGET(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 查询班级分页
     * @param {string} [name] 名称
     * @param {number} [page] 页码
     * @param {number} [showType] 1全部,2未上完
     * @param {number} [size] 每页显示数量
     * @param {number} [teaid] 老师ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.pageUsingGET = function (name, page, showType, size, teaid, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).pageUsingGET(name, page, showType, size, teaid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 查询科目分页
     * @param {string} [name] 科目名称
     * @param {number} [page] 页码
     * @param {number} [size] 每页显示数量
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.pageUsingGET1 = function (name, page, size, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).pageUsingGET1(name, page, size, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 查询科目级别分页
     * @param {number} [page] 页码
     * @param {number} [size] 每页显示数量
     * @param {string} [name] name
     * @param {string} [level] level
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.pageUsingGET2 = function (page, size, name, level, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).pageUsingGET2(page, size, name, level, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 查询用户分页
     * @param {number} [name] 名称、手机号、邮箱
     * @param {number} [page] 页码
     * @param {number} [roleid] 角色ID
     * @param {number} [size] 每页显示数量
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.pageUsingGET3 = function (name, page, roleid, size, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).pageUsingGET3(name, page, roleid, size, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 取消课时
     * @param {string} course 科目
     * @param {string} curTime 时间
     * @param {string} to 发给谁
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.sendCancelClassUsingPOST = function (course, curTime, to, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).sendCancelClassUsingPOST(course, curTime, to, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 发送网页
     * @param {string} content 内容
     * @param {string} title 标题
     * @param {string} to 发给谁
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.sendHtmlMailUsingPOST = function (content, title, to, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).sendHtmlMailUsingPOST(content, title, to, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 发送文本
     * @param {string} content 内容
     * @param {string} title 标题
     * @param {string} to 发给谁
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.sendTextMailUsingPOST = function (content, title, to, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).sendTextMailUsingPOST(content, title, to, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 可用时间规划
     * @param {number} userId userId
     * @param {UpdateUserCronEventReq} [updateUserCronEventReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.updateCronEventsUsingPUT = function (userId, updateUserCronEventReq, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateCronEventsUsingPUT(userId, updateUserCronEventReq, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 修改课时总结报告
     * @param {number} classHourId 课程 Id
     * @param {number} id 课程报告Id
     * @param {ClassHourSummaryRequest} [classHourSummaryRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.updateSummaryUsingPUT = function (classHourId, id, classHourSummaryRequest, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateSummaryUsingPUT(classHourId, id, classHourSummaryRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 修改科目(注:每项参数都必传)
     * @param {number} chours 总课时数
     * @param {number} id 名称
     * @param {number} isHome 是否首页显示
     * @param {string} link 链接
     * @param {string} name 名称
     * @param {string} remark 备注
     * @param {string} shortname 简称
     * @param {number} sort 顺序
     * @param {string} url 路径
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.updateUsingPUT = function (chours, id, isHome, link, name, remark, shortname, sort, url, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).updateUsingPUT(chours, id, isHome, link, name, remark, shortname, sort, url, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 上传
     * @param {number} type 类型1.图片，2.文件，3.受保护的(头像、科目等后期不清理的存放处)
     * @param {File} file file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.uploadImgUsingPOST = function (type, file, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).uploadImgUsingPOST(type, file, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 校验是否有冲突时间段
     * @param {VerifyClassTimeConflictReq} [verifyClassTimeConflictReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.validateConflictTimesUsingPOST = function (verifyClassTimeConflictReq, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).validateConflictTimesUsingPOST(verifyClassTimeConflictReq, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DefaultApi;
}(base_1.BaseAPI));
exports.DefaultApi = DefaultApi;
/**
 * ClassApi - axios parameter creator
 * @export
 */
var ClassApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 新增班级
         * @param {number} course 科目
         * @param {number} hours 总课时
         * @param {number} name 班级名称
         * @param {number} price 单价
         * @param {number} sids 学生ID集合
         * @param {number} students 学生集合
         * @param {number} teacher 老师
         * @param {number} teaprice 老师价格
         * @param {number} tid 老师ID
         * @param {number} timemodel 时间模板
         * @param {number} times 时间集合
         * @param {number} weeknum 周数量
         * @param {number} zoom zoom号
         * @param {number} [isaddhour] 是否补课时,默认0
         * @param {number} [pid] 续哪个班,默认0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsingPOST: function (course_1, hours_1, name_1, price_1, sids_1, students_1, teacher_1, teaprice_1, tid_1, timemodel_1, times_1, weeknum_1, zoom_1, isaddhour_1, pid_1) {
            var args_1 = [];
            for (var _i = 15; _i < arguments.length; _i++) {
                args_1[_i - 15] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([course_1, hours_1, name_1, price_1, sids_1, students_1, teacher_1, teaprice_1, tid_1, timemodel_1, times_1, weeknum_1, zoom_1, isaddhour_1, pid_1], args_1, true), void 0, function (course, hours, name, price, sids, students, teacher, teaprice, tid, timemodel, times, weeknum, zoom, isaddhour, pid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'course' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'course', course);
                    // verify required parameter 'hours' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'hours', hours);
                    // verify required parameter 'name' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'name', name);
                    // verify required parameter 'price' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'price', price);
                    // verify required parameter 'sids' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'sids', sids);
                    // verify required parameter 'students' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'students', students);
                    // verify required parameter 'teacher' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'teacher', teacher);
                    // verify required parameter 'teaprice' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'teaprice', teaprice);
                    // verify required parameter 'tid' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'tid', tid);
                    // verify required parameter 'timemodel' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'timemodel', timemodel);
                    // verify required parameter 'times' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'times', times);
                    // verify required parameter 'weeknum' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'weeknum', weeknum);
                    // verify required parameter 'zoom' is not null or undefined
                    (0, common_1.assertParamExists)('addUsingPOST', 'zoom', zoom);
                    localVarPath = "/japi/class";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (course !== undefined) {
                        localVarQueryParameter['course'] = course;
                    }
                    if (hours !== undefined) {
                        localVarQueryParameter['hours'] = hours;
                    }
                    if (isaddhour !== undefined) {
                        localVarQueryParameter['isaddhour'] = isaddhour;
                    }
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (pid !== undefined) {
                        localVarQueryParameter['pid'] = pid;
                    }
                    if (price !== undefined) {
                        localVarQueryParameter['price'] = price;
                    }
                    if (sids !== undefined) {
                        localVarQueryParameter['sids'] = sids;
                    }
                    if (students !== undefined) {
                        localVarQueryParameter['students'] = students;
                    }
                    if (teacher !== undefined) {
                        localVarQueryParameter['teacher'] = teacher;
                    }
                    if (teaprice !== undefined) {
                        localVarQueryParameter['teaprice'] = teaprice;
                    }
                    if (tid !== undefined) {
                        localVarQueryParameter['tid'] = tid;
                    }
                    if (timemodel !== undefined) {
                        localVarQueryParameter['timemodel'] = timemodel;
                    }
                    if (times !== undefined) {
                        localVarQueryParameter['times'] = times;
                    }
                    if (weeknum !== undefined) {
                        localVarQueryParameter['weeknum'] = weeknum;
                    }
                    if (zoom !== undefined) {
                        localVarQueryParameter['zoom'] = zoom;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 查询班级分页
         * @param {string} [name] 名称
         * @param {number} [page] 页码
         * @param {number} [showType] 1全部,2未上完
         * @param {number} [size] 每页显示数量
         * @param {number} [teaid] 老师ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsingGET: function (name_1, page_1, showType_1, size_1, teaid_1) {
            var args_1 = [];
            for (var _i = 5; _i < arguments.length; _i++) {
                args_1[_i - 5] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([name_1, page_1, showType_1, size_1, teaid_1], args_1, true), void 0, function (name, page, showType, size, teaid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/japi/class/page";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (showType !== undefined) {
                        localVarQueryParameter['showType'] = showType;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    if (teaid !== undefined) {
                        localVarQueryParameter['teaid'] = teaid;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 校验是否有冲突时间段
         * @param {VerifyClassTimeConflictReq} [verifyClassTimeConflictReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateConflictTimesUsingPOST: function (verifyClassTimeConflictReq_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([verifyClassTimeConflictReq_1], args_1, true), void 0, function (verifyClassTimeConflictReq, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/japi/class/verify-conflicts";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(verifyClassTimeConflictReq, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ClassApiAxiosParamCreator = ClassApiAxiosParamCreator;
/**
 * ClassApi - functional programming interface
 * @export
 */
var ClassApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ClassApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 新增班级
         * @param {number} course 科目
         * @param {number} hours 总课时
         * @param {number} name 班级名称
         * @param {number} price 单价
         * @param {number} sids 学生ID集合
         * @param {number} students 学生集合
         * @param {number} teacher 老师
         * @param {number} teaprice 老师价格
         * @param {number} tid 老师ID
         * @param {number} timemodel 时间模板
         * @param {number} times 时间集合
         * @param {number} weeknum 周数量
         * @param {number} zoom zoom号
         * @param {number} [isaddhour] 是否补课时,默认0
         * @param {number} [pid] 续哪个班,默认0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsingPOST: function (course, hours, name, price, sids, students, teacher, teaprice, tid, timemodel, times, weeknum, zoom, isaddhour, pid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addUsingPOST(course, hours, name, price, sids, students, teacher, teaprice, tid, timemodel, times, weeknum, zoom, isaddhour, pid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ClassApi.addUsingPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 查询班级分页
         * @param {string} [name] 名称
         * @param {number} [page] 页码
         * @param {number} [showType] 1全部,2未上完
         * @param {number} [size] 每页显示数量
         * @param {number} [teaid] 老师ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsingGET: function (name, page, showType, size, teaid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.pageUsingGET(name, page, showType, size, teaid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ClassApi.pageUsingGET']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 校验是否有冲突时间段
         * @param {VerifyClassTimeConflictReq} [verifyClassTimeConflictReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateConflictTimesUsingPOST: function (verifyClassTimeConflictReq, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.validateConflictTimesUsingPOST(verifyClassTimeConflictReq, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ClassApi.validateConflictTimesUsingPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ClassApiFp = ClassApiFp;
/**
 * ClassApi - factory interface
 * @export
 */
var ClassApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ClassApiFp)(configuration);
    return {
        /**
         *
         * @summary 新增班级
         * @param {number} course 科目
         * @param {number} hours 总课时
         * @param {number} name 班级名称
         * @param {number} price 单价
         * @param {number} sids 学生ID集合
         * @param {number} students 学生集合
         * @param {number} teacher 老师
         * @param {number} teaprice 老师价格
         * @param {number} tid 老师ID
         * @param {number} timemodel 时间模板
         * @param {number} times 时间集合
         * @param {number} weeknum 周数量
         * @param {number} zoom zoom号
         * @param {number} [isaddhour] 是否补课时,默认0
         * @param {number} [pid] 续哪个班,默认0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsingPOST: function (course, hours, name, price, sids, students, teacher, teaprice, tid, timemodel, times, weeknum, zoom, isaddhour, pid, options) {
            return localVarFp.addUsingPOST(course, hours, name, price, sids, students, teacher, teaprice, tid, timemodel, times, weeknum, zoom, isaddhour, pid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 查询班级分页
         * @param {string} [name] 名称
         * @param {number} [page] 页码
         * @param {number} [showType] 1全部,2未上完
         * @param {number} [size] 每页显示数量
         * @param {number} [teaid] 老师ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsingGET: function (name, page, showType, size, teaid, options) {
            return localVarFp.pageUsingGET(name, page, showType, size, teaid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 校验是否有冲突时间段
         * @param {VerifyClassTimeConflictReq} [verifyClassTimeConflictReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateConflictTimesUsingPOST: function (verifyClassTimeConflictReq, options) {
            return localVarFp.validateConflictTimesUsingPOST(verifyClassTimeConflictReq, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ClassApiFactory = ClassApiFactory;
/**
 * ClassApi - object-oriented interface
 * @export
 * @class ClassApi
 * @extends {BaseAPI}
 */
var ClassApi = /** @class */ (function (_super) {
    __extends(ClassApi, _super);
    function ClassApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 新增班级
     * @param {number} course 科目
     * @param {number} hours 总课时
     * @param {number} name 班级名称
     * @param {number} price 单价
     * @param {number} sids 学生ID集合
     * @param {number} students 学生集合
     * @param {number} teacher 老师
     * @param {number} teaprice 老师价格
     * @param {number} tid 老师ID
     * @param {number} timemodel 时间模板
     * @param {number} times 时间集合
     * @param {number} weeknum 周数量
     * @param {number} zoom zoom号
     * @param {number} [isaddhour] 是否补课时,默认0
     * @param {number} [pid] 续哪个班,默认0
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassApi
     */
    ClassApi.prototype.addUsingPOST = function (course, hours, name, price, sids, students, teacher, teaprice, tid, timemodel, times, weeknum, zoom, isaddhour, pid, options) {
        var _this = this;
        return (0, exports.ClassApiFp)(this.configuration).addUsingPOST(course, hours, name, price, sids, students, teacher, teaprice, tid, timemodel, times, weeknum, zoom, isaddhour, pid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 查询班级分页
     * @param {string} [name] 名称
     * @param {number} [page] 页码
     * @param {number} [showType] 1全部,2未上完
     * @param {number} [size] 每页显示数量
     * @param {number} [teaid] 老师ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassApi
     */
    ClassApi.prototype.pageUsingGET = function (name, page, showType, size, teaid, options) {
        var _this = this;
        return (0, exports.ClassApiFp)(this.configuration).pageUsingGET(name, page, showType, size, teaid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 校验是否有冲突时间段
     * @param {VerifyClassTimeConflictReq} [verifyClassTimeConflictReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassApi
     */
    ClassApi.prototype.validateConflictTimesUsingPOST = function (verifyClassTimeConflictReq, options) {
        var _this = this;
        return (0, exports.ClassApiFp)(this.configuration).validateConflictTimesUsingPOST(verifyClassTimeConflictReq, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ClassApi;
}(base_1.BaseAPI));
exports.ClassApi = ClassApi;
/**
 * ClassHourApi - axios parameter creator
 * @export
 */
var ClassHourApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 上传课时总结报告
         * @param {number} classHourId 课程 Id
         * @param {ClassHourSummaryRequest} [classHourSummaryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSummaryUsingPOST: function (classHourId_1, classHourSummaryRequest_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([classHourId_1, classHourSummaryRequest_1], args_1, true), void 0, function (classHourId, classHourSummaryRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'classHourId' is not null or undefined
                    (0, common_1.assertParamExists)('createSummaryUsingPOST', 'classHourId', classHourId);
                    localVarPath = "/japi/class-hour/{classHourId}/summary"
                        .replace("{".concat("classHourId", "}"), encodeURIComponent(String(classHourId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(classHourSummaryRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 冻结课时
         * @param {string} ids 课时ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frozenUsingPUT: function (ids_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([ids_1], args_1, true), void 0, function (ids, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'ids' is not null or undefined
                    (0, common_1.assertParamExists)('frozenUsingPUT', 'ids', ids);
                    localVarPath = "/japi/class_hour/frozen";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (ids !== undefined) {
                        localVarQueryParameter['ids'] = ids;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 根据班级查课时
         * @param {number} classid 班级ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClassHourByClassUsingGET: function (classid_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([classid_1], args_1, true), void 0, function (classid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'classid' is not null or undefined
                    (0, common_1.assertParamExists)('getClassHourByClassUsingGET', 'classid', classid);
                    localVarPath = "/japi/class_hour/getByClass/{classid}"
                        .replace("{".concat("classid", "}"), encodeURIComponent(String(classid)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 根据班级查课时
         * @param {number} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClassHourByIdUsingGET: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getClassHourByIdUsingGET', 'id', id);
                    localVarPath = "/japi/class-hour/{id}"
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取课时总结报告
         * @param {number} classHourId 课程 Id
         * @param {number} id 课程报告Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryUsingGET: function (classHourId_1, id_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([classHourId_1, id_1], args_1, true), void 0, function (classHourId, id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'classHourId' is not null or undefined
                    (0, common_1.assertParamExists)('getSummaryUsingGET', 'classHourId', classHourId);
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('getSummaryUsingGET', 'id', id);
                    localVarPath = "/japi/class-hour/{classHourId}/summary/{id}"
                        .replace("{".concat("classHourId", "}"), encodeURIComponent(String(classHourId)))
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 修改课时总结报告
         * @param {number} classHourId 课程 Id
         * @param {number} id 课程报告Id
         * @param {ClassHourSummaryRequest} [classHourSummaryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSummaryUsingPUT: function (classHourId_1, id_1, classHourSummaryRequest_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([classHourId_1, id_1, classHourSummaryRequest_1], args_1, true), void 0, function (classHourId, id, classHourSummaryRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'classHourId' is not null or undefined
                    (0, common_1.assertParamExists)('updateSummaryUsingPUT', 'classHourId', classHourId);
                    // verify required parameter 'id' is not null or undefined
                    (0, common_1.assertParamExists)('updateSummaryUsingPUT', 'id', id);
                    localVarPath = "/japi/class-hour/{classHourId}/summary/{id}"
                        .replace("{".concat("classHourId", "}"), encodeURIComponent(String(classHourId)))
                        .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(classHourSummaryRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ClassHourApiAxiosParamCreator = ClassHourApiAxiosParamCreator;
/**
 * ClassHourApi - functional programming interface
 * @export
 */
var ClassHourApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ClassHourApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 上传课时总结报告
         * @param {number} classHourId 课程 Id
         * @param {ClassHourSummaryRequest} [classHourSummaryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSummaryUsingPOST: function (classHourId, classHourSummaryRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSummaryUsingPOST(classHourId, classHourSummaryRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ClassHourApi.createSummaryUsingPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 冻结课时
         * @param {string} ids 课时ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frozenUsingPUT: function (ids, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.frozenUsingPUT(ids, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ClassHourApi.frozenUsingPUT']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 根据班级查课时
         * @param {number} classid 班级ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClassHourByClassUsingGET: function (classid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getClassHourByClassUsingGET(classid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ClassHourApi.getClassHourByClassUsingGET']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 根据班级查课时
         * @param {number} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClassHourByIdUsingGET: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getClassHourByIdUsingGET(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ClassHourApi.getClassHourByIdUsingGET']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取课时总结报告
         * @param {number} classHourId 课程 Id
         * @param {number} id 课程报告Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryUsingGET: function (classHourId, id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSummaryUsingGET(classHourId, id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ClassHourApi.getSummaryUsingGET']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 修改课时总结报告
         * @param {number} classHourId 课程 Id
         * @param {number} id 课程报告Id
         * @param {ClassHourSummaryRequest} [classHourSummaryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSummaryUsingPUT: function (classHourId, id, classHourSummaryRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSummaryUsingPUT(classHourId, id, classHourSummaryRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ClassHourApi.updateSummaryUsingPUT']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ClassHourApiFp = ClassHourApiFp;
/**
 * ClassHourApi - factory interface
 * @export
 */
var ClassHourApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ClassHourApiFp)(configuration);
    return {
        /**
         *
         * @summary 上传课时总结报告
         * @param {number} classHourId 课程 Id
         * @param {ClassHourSummaryRequest} [classHourSummaryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSummaryUsingPOST: function (classHourId, classHourSummaryRequest, options) {
            return localVarFp.createSummaryUsingPOST(classHourId, classHourSummaryRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 冻结课时
         * @param {string} ids 课时ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        frozenUsingPUT: function (ids, options) {
            return localVarFp.frozenUsingPUT(ids, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 根据班级查课时
         * @param {number} classid 班级ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClassHourByClassUsingGET: function (classid, options) {
            return localVarFp.getClassHourByClassUsingGET(classid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 根据班级查课时
         * @param {number} id id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClassHourByIdUsingGET: function (id, options) {
            return localVarFp.getClassHourByIdUsingGET(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取课时总结报告
         * @param {number} classHourId 课程 Id
         * @param {number} id 课程报告Id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryUsingGET: function (classHourId, id, options) {
            return localVarFp.getSummaryUsingGET(classHourId, id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 修改课时总结报告
         * @param {number} classHourId 课程 Id
         * @param {number} id 课程报告Id
         * @param {ClassHourSummaryRequest} [classHourSummaryRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSummaryUsingPUT: function (classHourId, id, classHourSummaryRequest, options) {
            return localVarFp.updateSummaryUsingPUT(classHourId, id, classHourSummaryRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ClassHourApiFactory = ClassHourApiFactory;
/**
 * ClassHourApi - object-oriented interface
 * @export
 * @class ClassHourApi
 * @extends {BaseAPI}
 */
var ClassHourApi = /** @class */ (function (_super) {
    __extends(ClassHourApi, _super);
    function ClassHourApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 上传课时总结报告
     * @param {number} classHourId 课程 Id
     * @param {ClassHourSummaryRequest} [classHourSummaryRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassHourApi
     */
    ClassHourApi.prototype.createSummaryUsingPOST = function (classHourId, classHourSummaryRequest, options) {
        var _this = this;
        return (0, exports.ClassHourApiFp)(this.configuration).createSummaryUsingPOST(classHourId, classHourSummaryRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 冻结课时
     * @param {string} ids 课时ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassHourApi
     */
    ClassHourApi.prototype.frozenUsingPUT = function (ids, options) {
        var _this = this;
        return (0, exports.ClassHourApiFp)(this.configuration).frozenUsingPUT(ids, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 根据班级查课时
     * @param {number} classid 班级ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassHourApi
     */
    ClassHourApi.prototype.getClassHourByClassUsingGET = function (classid, options) {
        var _this = this;
        return (0, exports.ClassHourApiFp)(this.configuration).getClassHourByClassUsingGET(classid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 根据班级查课时
     * @param {number} id id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassHourApi
     */
    ClassHourApi.prototype.getClassHourByIdUsingGET = function (id, options) {
        var _this = this;
        return (0, exports.ClassHourApiFp)(this.configuration).getClassHourByIdUsingGET(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取课时总结报告
     * @param {number} classHourId 课程 Id
     * @param {number} id 课程报告Id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassHourApi
     */
    ClassHourApi.prototype.getSummaryUsingGET = function (classHourId, id, options) {
        var _this = this;
        return (0, exports.ClassHourApiFp)(this.configuration).getSummaryUsingGET(classHourId, id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 修改课时总结报告
     * @param {number} classHourId 课程 Id
     * @param {number} id 课程报告Id
     * @param {ClassHourSummaryRequest} [classHourSummaryRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassHourApi
     */
    ClassHourApi.prototype.updateSummaryUsingPUT = function (classHourId, id, classHourSummaryRequest, options) {
        var _this = this;
        return (0, exports.ClassHourApiFp)(this.configuration).updateSummaryUsingPUT(classHourId, id, classHourSummaryRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ClassHourApi;
}(base_1.BaseAPI));
exports.ClassHourApi = ClassHourApi;
/**
 * CoreApi - axios parameter creator
 * @export
 */
var CoreApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get upload file token
         * @param {GetUploadFileTokenRequest} [getUploadFileTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUploadFileTokenUsingPOST: function (getUploadFileTokenRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([getUploadFileTokenRequest_1], args_1, true), void 0, function (getUploadFileTokenRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/japi/core/customize-file";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(getUploadFileTokenRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Upload file
         * @param {File} file Files to upload
         * @param {UploadFilesUsingPOSTTypeEnum} type Upload type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFilesUsingPOST: function (file_1, type_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([file_1, type_1], args_1, true), void 0, function (file, type, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'file' is not null or undefined
                    (0, common_1.assertParamExists)('uploadFilesUsingPOST', 'file', file);
                    // verify required parameter 'type' is not null or undefined
                    (0, common_1.assertParamExists)('uploadFilesUsingPOST', 'type', type);
                    localVarPath = "/japi/core/file";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                    if (file !== undefined) {
                        localVarFormParams.append('file', file);
                    }
                    if (type !== undefined) {
                        localVarFormParams.append('type', type);
                    }
                    localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = localVarFormParams;
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CoreApiAxiosParamCreator = CoreApiAxiosParamCreator;
/**
 * CoreApi - functional programming interface
 * @export
 */
var CoreApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CoreApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get upload file token
         * @param {GetUploadFileTokenRequest} [getUploadFileTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUploadFileTokenUsingPOST: function (getUploadFileTokenRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUploadFileTokenUsingPOST(getUploadFileTokenRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CoreApi.getUploadFileTokenUsingPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Upload file
         * @param {File} file Files to upload
         * @param {UploadFilesUsingPOSTTypeEnum} type Upload type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFilesUsingPOST: function (file, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.uploadFilesUsingPOST(file, type, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['CoreApi.uploadFilesUsingPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.CoreApiFp = CoreApiFp;
/**
 * CoreApi - factory interface
 * @export
 */
var CoreApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CoreApiFp)(configuration);
    return {
        /**
         *
         * @summary Get upload file token
         * @param {GetUploadFileTokenRequest} [getUploadFileTokenRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUploadFileTokenUsingPOST: function (getUploadFileTokenRequest, options) {
            return localVarFp.getUploadFileTokenUsingPOST(getUploadFileTokenRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Upload file
         * @param {File} file Files to upload
         * @param {UploadFilesUsingPOSTTypeEnum} type Upload type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFilesUsingPOST: function (file, type, options) {
            return localVarFp.uploadFilesUsingPOST(file, type, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CoreApiFactory = CoreApiFactory;
/**
 * CoreApi - object-oriented interface
 * @export
 * @class CoreApi
 * @extends {BaseAPI}
 */
var CoreApi = /** @class */ (function (_super) {
    __extends(CoreApi, _super);
    function CoreApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get upload file token
     * @param {GetUploadFileTokenRequest} [getUploadFileTokenRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreApi
     */
    CoreApi.prototype.getUploadFileTokenUsingPOST = function (getUploadFileTokenRequest, options) {
        var _this = this;
        return (0, exports.CoreApiFp)(this.configuration).getUploadFileTokenUsingPOST(getUploadFileTokenRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Upload file
     * @param {File} file Files to upload
     * @param {UploadFilesUsingPOSTTypeEnum} type Upload type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CoreApi
     */
    CoreApi.prototype.uploadFilesUsingPOST = function (file, type, options) {
        var _this = this;
        return (0, exports.CoreApiFp)(this.configuration).uploadFilesUsingPOST(file, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CoreApi;
}(base_1.BaseAPI));
exports.CoreApi = CoreApi;
/**
 * @export
 */
exports.UploadFilesUsingPOSTTypeEnum = {
    COURSE_SUMMARY_HOMEWORK: 'COURSE_SUMMARY_HOMEWORK',
    COURSE_SUMMARY_NOTE: 'COURSE_SUMMARY_NOTE',
    COURSE_SUMMARY_VIDEO: 'COURSE_SUMMARY_VIDEO'
};
/**
 * UserApi - axios parameter creator
 * @export
 */
var UserApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary 登录
         * @param {string} password 密码
         * @param {string} username 用户名
         * @param {string} [openid] 微信OPENID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginUsingPOST: function (password_1, username_1, openid_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([password_1, username_1, openid_1], args_1, true), void 0, function (password, username, openid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'password' is not null or undefined
                    (0, common_1.assertParamExists)('loginUsingPOST', 'password', password);
                    // verify required parameter 'username' is not null or undefined
                    (0, common_1.assertParamExists)('loginUsingPOST', 'username', username);
                    localVarPath = "/japi/user/login";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (openid !== undefined) {
                        localVarQueryParameter['openid'] = openid;
                    }
                    if (password !== undefined) {
                        localVarQueryParameter['password'] = password;
                    }
                    if (username !== undefined) {
                        localVarQueryParameter['username'] = username;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 微信登录回调
         * @param {string} code code
         * @param {string} state state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithWechatCallbackUsingGET: function (code_1, state_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([code_1, state_1], args_1, true), void 0, function (code, state, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'code' is not null or undefined
                    (0, common_1.assertParamExists)('loginWithWechatCallbackUsingGET', 'code', code);
                    // verify required parameter 'state' is not null or undefined
                    (0, common_1.assertParamExists)('loginWithWechatCallbackUsingGET', 'state', state);
                    localVarPath = "/japi/user/login/wechat/callback";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (code !== undefined) {
                        localVarQueryParameter['code'] = code;
                    }
                    if (state !== undefined) {
                        localVarQueryParameter['state'] = state;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 微信登录
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithWechatUsingGET: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/japi/user/login/wechat";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 获取当前登录状态
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        meUsingGET: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/japi/user/me";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 查询用户分页
         * @param {number} [name] 名称、手机号、邮箱
         * @param {number} [page] 页码
         * @param {number} [roleid] 角色ID
         * @param {number} [size] 每页显示数量
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsingGET3: function (name_1, page_1, roleid_1, size_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([name_1, page_1, roleid_1, size_1], args_1, true), void 0, function (name, page, roleid, size, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/japi/user/page";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (page !== undefined) {
                        localVarQueryParameter['page'] = page;
                    }
                    if (roleid !== undefined) {
                        localVarQueryParameter['roleid'] = roleid;
                    }
                    if (size !== undefined) {
                        localVarQueryParameter['size'] = size;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary 可用时间规划
         * @param {number} userId userId
         * @param {UpdateUserCronEventReq} [updateUserCronEventReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCronEventsUsingPUT: function (userId_1, updateUserCronEventReq_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([userId_1, updateUserCronEventReq_1], args_1, true), void 0, function (userId, updateUserCronEventReq, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'userId' is not null or undefined
                    (0, common_1.assertParamExists)('updateCronEventsUsingPUT', 'userId', userId);
                    localVarPath = "/japi/user/{userId}/cron-events"
                        .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateUserCronEventReq, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.UserApiAxiosParamCreator = UserApiAxiosParamCreator;
/**
 * UserApi - functional programming interface
 * @export
 */
var UserApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.UserApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary 登录
         * @param {string} password 密码
         * @param {string} username 用户名
         * @param {string} [openid] 微信OPENID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginUsingPOST: function (password, username, openid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loginUsingPOST(password, username, openid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.loginUsingPOST']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 微信登录回调
         * @param {string} code code
         * @param {string} state state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithWechatCallbackUsingGET: function (code, state, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loginWithWechatCallbackUsingGET(code, state, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.loginWithWechatCallbackUsingGET']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 微信登录
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithWechatUsingGET: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.loginWithWechatUsingGET(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.loginWithWechatUsingGET']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 获取当前登录状态
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        meUsingGET: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.meUsingGET(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.meUsingGET']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 查询用户分页
         * @param {number} [name] 名称、手机号、邮箱
         * @param {number} [page] 页码
         * @param {number} [roleid] 角色ID
         * @param {number} [size] 每页显示数量
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsingGET3: function (name, page, roleid, size, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.pageUsingGET3(name, page, roleid, size, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.pageUsingGET3']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary 可用时间规划
         * @param {number} userId userId
         * @param {UpdateUserCronEventReq} [updateUserCronEventReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCronEventsUsingPUT: function (userId, updateUserCronEventReq, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCronEventsUsingPUT(userId, updateUserCronEventReq, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UserApi.updateCronEventsUsingPUT']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.UserApiFp = UserApiFp;
/**
 * UserApi - factory interface
 * @export
 */
var UserApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.UserApiFp)(configuration);
    return {
        /**
         *
         * @summary 登录
         * @param {string} password 密码
         * @param {string} username 用户名
         * @param {string} [openid] 微信OPENID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginUsingPOST: function (password, username, openid, options) {
            return localVarFp.loginUsingPOST(password, username, openid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 微信登录回调
         * @param {string} code code
         * @param {string} state state
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithWechatCallbackUsingGET: function (code, state, options) {
            return localVarFp.loginWithWechatCallbackUsingGET(code, state, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 微信登录
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithWechatUsingGET: function (options) {
            return localVarFp.loginWithWechatUsingGET(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 获取当前登录状态
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        meUsingGET: function (options) {
            return localVarFp.meUsingGET(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 查询用户分页
         * @param {number} [name] 名称、手机号、邮箱
         * @param {number} [page] 页码
         * @param {number} [roleid] 角色ID
         * @param {number} [size] 每页显示数量
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pageUsingGET3: function (name, page, roleid, size, options) {
            return localVarFp.pageUsingGET3(name, page, roleid, size, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary 可用时间规划
         * @param {number} userId userId
         * @param {UpdateUserCronEventReq} [updateUserCronEventReq]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCronEventsUsingPUT: function (userId, updateUserCronEventReq, options) {
            return localVarFp.updateCronEventsUsingPUT(userId, updateUserCronEventReq, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.UserApiFactory = UserApiFactory;
/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
var UserApi = /** @class */ (function (_super) {
    __extends(UserApi, _super);
    function UserApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary 登录
     * @param {string} password 密码
     * @param {string} username 用户名
     * @param {string} [openid] 微信OPENID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.loginUsingPOST = function (password, username, openid, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).loginUsingPOST(password, username, openid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 微信登录回调
     * @param {string} code code
     * @param {string} state state
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.loginWithWechatCallbackUsingGET = function (code, state, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).loginWithWechatCallbackUsingGET(code, state, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 微信登录
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.loginWithWechatUsingGET = function (options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).loginWithWechatUsingGET(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 获取当前登录状态
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.meUsingGET = function (options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).meUsingGET(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 查询用户分页
     * @param {number} [name] 名称、手机号、邮箱
     * @param {number} [page] 页码
     * @param {number} [roleid] 角色ID
     * @param {number} [size] 每页显示数量
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.pageUsingGET3 = function (name, page, roleid, size, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).pageUsingGET3(name, page, roleid, size, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary 可用时间规划
     * @param {number} userId userId
     * @param {UpdateUserCronEventReq} [updateUserCronEventReq]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.updateCronEventsUsingPUT = function (userId, updateUserCronEventReq, options) {
        var _this = this;
        return (0, exports.UserApiFp)(this.configuration).updateCronEventsUsingPUT(userId, updateUserCronEventReq, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UserApi;
}(base_1.BaseAPI));
exports.UserApi = UserApi;
